
<div class="px-3">
  <div class="d-flex align-items-center justify-content-between">
    <span class="title">{{isEdit ? 'Edit Contract Role' : 'Add Contract Role'}}</span>
    <button class="btn button btn-primary btn-save" (click)="save()">Save</button>
  </div>
  <div class="mt-3 row mx-0" style="font-size: 14px;">
    <div [formGroup]="roleForm" class="col-12 p-0">
      <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">SSO
        <span style="color: red;">*</span>
      </div>
      <div class="col-12 p-0 row m-0">
        <div class="col-6 p-0">
          <mat-form-field floatLabel="never" appearance="outline" class="col-11 p-0">
            <input formControlName="sso" name="sso" matInput placeholder="" style="color: #18181a;" [readonly]="isEdit">
            <mat-hint align="end">{{roleForm.controls.sso.value.length || 0}} / 50</mat-hint>
            <mat-error>{{roleForm.controls.sso.errors?.message}}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-6 p-0 d-flex justify-content-center align-items-center" *ngIf="!isEdit">
          <button class="btn btn-primary button" (click)="search()"
            style="height: 43px; margin-top: -9px; width: 100px;">Search</button>
        </div>
      </div>
      <div class="row m-0">
        <div class="col-xl-6 col-md-6 col-sm-6 p-0">
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3">Full Name
          </div>
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
            <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
              <input formControlName="fullName" name="fullName" matInput readonly>
            </mat-form-field>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-6 p-0">
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Email
          </div>
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
            <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
              <input formControlName="email" name="email" matInput readonly>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-6 d-flex flex-column p-0">
        <span>ROLE</span>
        <mat-form-field appearance="outline" class="col-11 p-0">
          <mat-select formControlName="roles">
            <mat-option *ngFor="let role of roles" [value]="role.value">
              {{role.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row m-0">
        <div class="col-6 d-flex flex-column p-0">SET PRIMARY
          <mat-checkbox formControlName="isPrimary" style="margin-top: 10px;"></mat-checkbox>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-6 p-0">
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto text-normal">
            ACCESS TYPE
          </div>
          <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-2 ml-auto text-normal">
            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
              formControlName="accessType" name="accessType">
              <mat-radio-button class="example-radio-button mr-3" *ngFor="let option of accessTypeOptions" [value]="option.value">
                {{option.display}}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>